<template>
    <router-link :to="to" @click.native="clickHandler" :key="to">
        <slot></slot>
    </router-link>
</template>
<script>
import { Collapse } from 'bootstrap';
export default {
    name: 'base-link',
    props: ['to'],
    data() {
        return {
            currentRoute: null
        }
    },
    created(){
        this.currentRoute = this.$route.path
    },
    beforeUpdate(){
        this.currentRoute = this.$route.path
        if (document.querySelectorAll('input')[1])
            document.querySelectorAll('input')[1].value = ""
    },
    methods: {
        closeNavbar() {
            let navbar = document.querySelector('.navbar-collapse.show');
            if (navbar) {
                new Collapse(navbar, {
                    toggle: false,
                }).hide();
            }
        },
        clickHandler($event){
            this.closeNavbar()
            this.$forceUpdate()
            // console.log(this.currentRoute, this.$route, this.to)
            if (!($event.ctrlKey || $event.metaKey) && this.currentRoute === this.to && this.currentRoute === '/procedureKinds') {
                const query = { ...this.$route.query, _: 'refresh' };
                const newRoute = { ...this.$route, query };
                this.$router.replace(newRoute);
            }
        }
    }
}
</script>
